import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

import RichText from "./richText/Parser"

export default function ContactBlock({ component }) {
  const { richtitle, button, buttonIconMedia, backgroundColor } = component

  return (
    <div
      className={`relative ${
        backgroundColor === "blue" ? "bg-charlestonGreen-100" : ""
      } overflow-hidden`}
    >
      <div className="relative min-h-[400px] max-w-7xl px-4 py-12 mx-auto sm:px-6 lg:pt-24 lg:pb-28 lg:px-8 flex align-items">
        <div className="absolute right-0 top-1/2 -translate-y-1/2 ">
          <svg
            width="350px"
            height="535px"
            viewBox="0 0 445 680"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <filter id="filter-swizi">
                <feColorMatrix
                  in="SourceGraphic"
                  type="matrix"
                  values="0 0 0 0 0.149020 0 0 0 0 0.458824 0 0 0 0 0.650980 0 0 0 1.000000 0"
                />
              </filter>
              <polygon
                id="path-2"
                points="0 0 421.645136 0 421.645136 518.102341 0 518.102341"
              />
            </defs>
            <g
              id="Lot-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
              opacity="0.146452404"
            >
              <g id="Group-21" transform="translate(-0.000000, 0.000000)">
                <g filter="url(#filter-swizi)" id="Group-18">
                  <g>
                    <mask id="mask-3" fill="white">
                      <use xlinkHref="#path-2" />
                    </mask>
                    <g id="Clip-17" />
                    <path
                      d="M197.516074,504.256907 C206.188802,513.123509 217.782149,518.040192 230.157069,518.102341 L230.397026,518.102341 C242.689676,518.102341 254.241887,513.309956 262.962607,504.574558 C271.772453,495.749389 276.626439,484.003213 276.626439,471.511248 C276.626439,459.109054 271.820445,447.445744 263.106581,438.682724 L135.655182,309.937455 C117.343042,291.451557 104.378513,269.195281 98.1464895,245.571726 C95.6783613,236.18031 94.4168735,227.438006 94.4168735,219.593411 C94.4168735,152.921261 148.290628,98.6858313 214.505023,98.6858313 C266.363139,98.6858313 312.167485,131.942494 328.477699,181.454593 C331.638274,191.018646 337.637197,199.208513 345.857435,205.174825 C354.01597,211.065176 363.648526,214.17263 373.713004,214.17263 C389.083958,214.17263 403.152289,207.018581 412.304931,194.547332 C421.327311,182.262531 423.966837,166.897898 419.55163,152.368824 C391.949729,62.1076459 307.971667,0 214.347337,0 C212.880172,0 211.406151,0.0138109064 209.938986,0.0345272659 C96.5559179,2.43762497 4.40560886,93.6862832 0.154943604,207.750559 C0.0521049289,210.422969 0.00411354702,213.081569 -0.00300080353,215.719452 C-0.0918692167,270.935455 22.875435,326.096215 63.009942,367.059364 L197.516074,504.256907 Z"
                      id="Fill-16"
                      fill="#226996"
                      mask="url(#mask-3)"
                    />
                  </g>
                </g>
                <path
                  d="M247.480587,175.743093 C238.814714,166.876491 227.221368,161.959808 214.846447,161.897659 L214.599634,161.897659 C202.306985,161.897659 190.754773,166.690044 182.04091,175.425442 C173.231063,184.243706 168.377078,195.982976 168.377078,208.481846 C168.377078,220.88404 173.176216,232.540445 181.89008,241.317276 L309.348334,370.05564 C327.660474,388.548443 340.625003,410.811624 346.850171,434.428274 C349.325155,443.826596 350.579787,452.5689 350.579787,460.399684 C350.579787,527.078739 296.712889,581.314169 230.491638,581.314169 C178.633522,581.314169 132.836031,548.057506 116.525818,498.545407 C113.358386,488.974449 107.352608,480.777676 99.1460814,474.81827 C90.9875465,468.934824 81.3481346,465.82737 71.2836563,465.82737 C55.9127022,465.82737 41.8512274,472.974514 32.6917293,485.438857 C23.6762054,497.730563 21.0298235,513.095197 25.4518866,527.631176 C53.0469311,617.892354 137.031849,680 230.65618,680 C232.116489,680 233.59051,679.986189 235.057675,679.958567 C348.440742,677.562375 440.591052,586.313717 444.841717,472.228725 C444.944555,469.577031 444.992547,466.925337 445,464.273643 C445.095386,409.064545 422.121225,353.903785 381.986718,312.933731 L247.480587,175.743093 Z"
                  id="Fill-19"
                  fill="#1A5274"
                />
              </g>
            </g>
          </svg>
        </div>
        <div className="flex justify-center	flex-col relative ">
          {richtitle && (
            <RichText stringHtml={richtitle} option="sectionTitle" />
          )}
          {button?.url && (
            <div className="flex mt-6">
              <Link
                to={button.url}
                className="px-12 py-2 md:px-24 md:py-4 text-base uppercase align-middle border border-transparent btn focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orangeSafe-500"
                target={button.target}
              >
                {buttonIconMedia?.localFile?.childImageSharp
                  ?.gatsbyImageData && (
                  <GatsbyImage
                    className="w-5 h-5 mr-2 align-middle "
                    image={
                      buttonIconMedia?.localFile?.childImageSharp
                        ?.gatsbyImageData
                    }
                    alt={buttonIconMedia?.altText}
                  />
                )}
                <span className="align-middle">{button.title}</span>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
